<div class="bg-vid-container">
  <!--video playsinline="true" webkit-playsinline="true" oncanplay="this.play()" autoplay="true" muted onloadedmetadata="this.muted = true" loop>
    <source src="https://media.gozero.tech/default/comcard/web-bg-vid.mp4" type="video/mp4">
  </video -->
</div>

<div class="dark-overlay"></div>


<div class="page-container">
  <!--app-newlayout-header></app-newlayout-header-->
  <div class="contentwrapper">
    <div class="content-spacing row">
      <div class="content-section col-md-6">
        <div class="branding-section">
          <div class="mb-3">
            <img id="desktop-logo" src="./assets/img/zero/logo/zero-brandcard-logo.svg">
            <img id="mobile-logo" src="./assets/img/zero/logo/zero-brandcard-logo-v.svg">
          </div>
          <p><span>Conserve the environment</span> with the world’s most advanced dynamic digital business card</p>
        </div>
      </div>
      <div class="content-section col-md-6">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
  <app-newlayout-footer></app-newlayout-footer>
</div>
